import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { fromJS } from 'immutable';
import validatejs from 'validate.js';
import { Col, Row } from 'react-flexbox-grid';
import RaisedButton from 'material-ui/RaisedButton';
import IconButton from 'material-ui/IconButton';
import Delete from 'material-ui/svg-icons/action/delete';

import { Field, FieldArray, formValueSelector, reduxForm, submit } from 'redux-form/immutable';

import { TextField } from 'redux-form-material-ui';
import api from '../../../utils/api';
import { updateConfigurations } from '../actions';

// const formValidation = (values) => validateConstraints(values.toJS(), {
//   "members.email": {
//     presence: {
//       message: "^Bitte wählen Sie ein Preismodel"
//       allowEmpty: false,
//     }
//   }
// });

const validate = values => {
    const errors = {};
    const membersArrayErrors = [];
    const constraints = {
        email: {
            email: {
                message: '^Bitte geben Sie eine gültige E-Mail-Adresse ein',
            },
        },
    };
    const members = values.get('members') || fromJS([]);
    members.forEach((member, memberIndex) => {
        membersArrayErrors[memberIndex] = validatejs(member.toJS(), constraints);
    });
    errors.members = membersArrayErrors;
    return errors;
};

class CustomerOrdersSettings extends Component {
    handleSubmit = () => {
        this.props.dispatch(submit('customerOrderSettings'));
    };

    componentDidMount = () => {
        this.props.getSettings();
    };

    renderConfigurations = ({ fields, meta: { touched, error } }) => {
        let labelName = 'Konfigurationen hinzufügen';
        if (fields.length > 0) {
            labelName = 'Weitere Konfigurationen hinzufügen';
        }
        return (
            <div>
                <h2>Einstellungen</h2>
                {fields.map((receiver, index) => (
                    console.table(receiver),
                    <Row key={index}>
                        <Col xs={3}>
                            <Field
                                floatingLabelText="Erfasser"
                                name={`${receiver}.users`}
                                component={TextField}
                                type="text"
                                style={{ width: '100%' }}
                                label="Erfasser"
                            />
                        </Col>
                        <Col xs={3}>
                            <Field
                                onKeyPress={event => {
                                    if (event.key === 'Enter') {
                                        this.props.updateConfigurations(
                                            this.props.email_configurations.push(
                                                fromJS({ emails: '', users: '' })
                                            )
                                        );
                                    }
                                }}
                                floatingLabelText="E-Mail-Adressen"
                                name={`${receiver}.emails`}
                                component={TextField}
                                type="text"
                                style={{ width: '100%' }}
                                autoFocus={index === fields.length - 1 ? true : false}
                                label="E-Mail-Adressen"
                            />
                        </Col>
                        <Col xs={4}>
                            <IconButton
                                tooltip="SVG Icon"
                                style={{ marginTop: '25px' }}
                                onClick={() =>
                                    this.props.updateConfigurations(
                                        this.props.email_configurations.delete(index)
                                    )
                                }>
                                <Delete />
                            </IconButton>
                        </Col>
                    </Row>
                ))}
                <Row>
                    <Col xs={5}>
                        <RaisedButton
                            label={labelName}
                            style={{ marginTop: '25px' }}
                            onClick={() =>
                                this.props.updateConfigurations(
                                    this.props.email_configurations.push(
                                        fromJS({
                                            emails: '',
                                            users: '',
                                        })
                                    )
                                )
                            }
                        />
                    </Col>
                </Row>
            </div>
        );
    };

    render() {
        const { handleSubmit, email_configurations, initialValues } = this.props;
        return (
            <form
                onSubmit={handleSubmit}
                onKeyPress={event => {
                    if (event.key === 'Enter') {
                        event.preventDefault();
                        event.stopPropagation();
                    }
                }}>
                <div>
                    <h3>Kundenbestellungen</h3>
                    <p>Bitte geben Sie mehrere E-Mail-Adressen und Erfasser kommagetrennt an</p>
                    <Row>
                        <Col xs={12}>
                            <FieldArray
                                name="email_configurations"
                                component={this.renderConfigurations}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <RaisedButton
                            primary={true}
                            label="Speichern"
                            style={{ marginTop: '25px' }}
                            onClick={this.handleSubmit}
                        />
                    </Row>
                </div>
            </form>
        );
    }
}

CustomerOrdersSettings.propTypes = {
    dispatch: PropTypes.func.isRequired,
};

const selector = formValueSelector('customerOrderSettings'); // <-- same as form name

const mapStateToProps = (state, props) => ({
    customer_order_setting: selector(state, 'customer_order_setting'),
    email_configurations: selector(state, 'email_configurations'),
});

const mapDispatchToProps = dispatch => ({
    getSettings: payload => dispatch(api.actions.settings.get(payload)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(
    reduxForm({ form: 'customerOrderSettings', enableReinitialize: true, validate })(
        CustomerOrdersSettings
    )
);
